import { useLayoutEffect } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, Switch, useParams, useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';
import {
    changeLoanFormat,
    LOANFORMAT_ALL_OBJECT,
    LOANFORMAT_EPRESS,
    loanFormatKeyToObject
} from '../../store/loanFormat/actions';
import { CataloguePage } from './CataloguePage';
import { GenreEntryPage } from '../entrypages/genre/GenreEntryPage';
import { PublisherEntryPage } from '../entrypages/publishers/PublisherEntryPage';
import { NewReleasesEntryPage } from '../entrypages/newReleases/NewReleasesEntryPage';
import { FeaturedEntryPage } from '../entrypages/featured/FeaturedEntryPage';
import { PageNotFound } from '../PageNotFound';
import { BundlesOverviewPage } from '../../shared/bundles/BundlesOverviewPage';
import { ProductSelectionProvider } from '../../shared/product-selection/ProductSelectionContext';
import { ProductTypePage } from '../product-type/ProductTypePage';
import { CheckLoanFormatAndProductType } from '../product-type/CheckLoanFormatAndProductType';
import { CheckLoanFormat } from '../../shared/components/CheckLoanFormat';

export const CatalogueTemplate = () => {
    const dispatch = useDispatch();
    const { path } = useRouteMatch();
    const { loanFormat } = useParams<{ loanFormat: string }>();

    useLayoutEffect(() => {
        const loanFormatString = !loanFormat ? LOANFORMAT_ALL_OBJECT : loanFormatKeyToObject(loanFormat);
        dispatch(changeLoanFormat(loanFormatString));
    }, [dispatch, loanFormat]);

    return (
        <CheckLoanFormat>
            <Switch>
                <Route path={`${path}/featured`} component={FeaturedEntryPage} />
                <Redirect exact from={path} to={`${path}/featured`} />
                <Route exact path={`${path}/bundles`} component={BundlesOverviewPage} />
                {loanFormat !== LOANFORMAT_EPRESS ? (
                    <Route path={`${path}/newreleases`} component={NewReleasesEntryPage} />
                ) : (
                    <Redirect exact from={`${path}/newreleases`} to={`${path}/featured`} />
                )}
                <Route path={`${path}/newreleases`} component={NewReleasesEntryPage} />
                <Route
                    path={`${path}/products`}
                    render={() => (
                        <ProductSelectionProvider>
                            <CataloguePage />
                        </ProductSelectionProvider>
                    )}
                />
                <Route path={`${path}/genres/:genre?/:subGenre?`} component={GenreEntryPage} />
                <Route path={`${path}/publishers/:item?/:subItem?`} component={PublisherEntryPage} />
                <Route
                    path={`${path}/:productType`}
                    render={() => (
                        <CheckLoanFormatAndProductType>
                            {({ loanFormat, productType }) => (
                                <ProductSelectionProvider>
                                    <ProductTypePage loanFormat={loanFormat} productType={productType} />
                                </ProductSelectionProvider>
                            )}
                        </CheckLoanFormatAndProductType>
                    )}
                />
                <Route component={PageNotFound} />
            </Switch>
        </CheckLoanFormat>
    );
};
